import { RBEditorial } from 'store/railsBuilder/reducer.types';
import { Entitlement } from 'store/user/reducer.types';
import { isCapabilityValid } from 'store/utils';

import { TECHNICAL_DEVICE_TYPE } from 'services/data-manager/constants';

export default function checkVodEntitlement(
    vodItem: RBEditorial,
    entitlements: Entitlement[],
) {
    const technical = vodItem.technicals?.find(({ deviceType }) =>
        deviceType.includes(TECHNICAL_DEVICE_TYPE),
    );

    return !!technical?.products.some((product) => {
        const maybeEntitlement = entitlements.find(
            ({ productId }) => product.id === productId,
        );

        return isCapabilityValid(maybeEntitlement);
    });
}
